import api from './BaseApi';
import dateFormat from '../utils/dateformat';

export function getRegularMenuDay(start_date, id) {
  id = id || '21ffc672-02ca-411b-b210-97351f996512'
  const formattedDay = dateFormat(start_date, 'yyyy-mm-dd');
  return api.get(`menu/${id}`, {
    start_date: formattedDay,
    date_range: 'day',
  });
}

export function getRegularMenuWeek(start_date, id) {
  id = id || '21ffc672-02ca-411b-b210-97351f996512'
  const formattedDay = dateFormat(start_date, 'yyyy-mm-dd');
  return api.get(`menu/${id}`, {
    start_date: formattedDay,
    date_range: 'week',
  });
}